<template>
    <div class="py-3">
        <div v-if="stats">
            <div v-for="group of stats.iframe" :key="group.user.id">
                <div class="row">
                    <div class="col-md-3">
                        <h2 class="text-center">{{ group.name }}</h2>
                        <p><strong>Used by:</strong> {{ group.stats.unique_rows }} properties</p>
                        <p><strong>Active tokens:</strong> {{ group.stats.num_rows }}</p>
                    </div>
                    <div class="col-md-9">
                        <table class="table">
                            <thead>
                                <th>Property</th>
                                <th>Token Expires</th>
                            </thead>
                            <tbody>
                                <tr v-for="row in group.rows" :key="row.id">
                                    <td>{{ row.team_name }}</td>
                                    <td>{{ row.expires }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            Loading..
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.getStats();
    },
    data() {
        return {
            stats: null
        };
    },
    methods: {
        getStats() {
            axios.get("/api/admin/stats").then(response => {
                this.stats = response.data;
            });
        }
    }
};
</script>
